import Dropzone from 'dropzone';

if ($('#contest_image_dropzone').length) {
  (function () {
    var $zone = $('#contest_image_dropzone');
    var $progress_bar = $zone.find('.contest_image_progress_bar span');
    var $error = $('#contest_image_error');

    if (!$zone.hasClass('contest_image_preview')) {
      var dropzone = new Dropzone('#contest_image_dropzone', {
        url: '/ajax/social-feed/contest-upload/',
        fallback: function () {
          $zone.hide();
          $('.contest_image_mobile').show();
        },
      });

      dropzone.on('sending', function () {
        $zone.addClass('active');
      });

      dropzone.on('uploadprogress', function (event, progress) {
        // console.log(progress);
        $progress_bar.css({ width: progress + 1 + '%' });
      });

      dropzone.on('success', function (event, response) {
        $zone.removeClass('active');

        if (response === 'false') {
          $error.html('You must upload a PNG or JPG file.').show();
        } else {
          $error.hide();
          dropzone.disable();
          $zone.addClass('contest_image_preview').html('<img src="' + response + '"><input type="hidden" name="file" value="' + response + '">');
        }
      });
    }
  })();
}

$('.contest_thankyou_dialog .button').click(function () {
  $('.contest_thankyou_dialog, .contest_thankyou_shade').remove();
});
